// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import store from './store/store'
import moment from 'moment'
import Vue2Filters from 'vue2-filters'
import * as VueGoogleMaps from 'vue2-google-maps'

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('token') || to.name.toLowerCase() === 'login') {
    next()
  } else {
    next({path: '/login'})
  }
})

Vue.use(Vue2Filters)
Vue.use(Vuetify)
Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCCBtsl0lxjLoyBrPATwjJjWat-zwpfsQ0',
    libraries: 'places'
  }
})

const formatDate = function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
}
Vue.filter('formatDate', formatDate)
const formatDate2 = function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
}
Vue.filter('formatDate2', formatDate2)

const formatFechaVencimiento = function (value) {
  if (!value || value === 'SIN/F') return 'SIN/F'
  return moment(String(value)).format('DD/MM/YYYY')
}
Vue.filter('formatFechaVencimiento', formatFechaVencimiento)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js